<div class="details">
  <div
    class="edit-panel-header pl-5 pr-3"
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <div
      fxLayout="row"
      fxLayoutAlign="start center">
      <div class="header-label">{{ 'COMMUNICATIONS.RECIPIENT-DETAILS' | translate }}</div>
    </div>
    <div>
      <button
        class="button is-small is-ghost"
        (click)="closeClick()">
        <i class="icon icon-close-X"></i>
      </button>
    </div>
  </div>
  <div class="body">
    <topo-avatar
      [name]="recipient?.name"
    [showName]="true"></topo-avatar>
    <topo-workflow-gen-transition-select
      [hostObject]="recipient"
      [workflow]="recipientWorkflow"
      [hideSingleWorkflow]="false"
      [isEdit]="true"
    (stepChanged)="onWorkflowStepChanged($event)"></topo-workflow-gen-transition-select>
  </div>
  @if (dataset) {
    <div
      style="margin-top: -22px">
      <topo-tabs
        [selectedTabIndex]="selectedTabIndex"
        [tabs]="tabs"
      (selectedTabIndexChanged)="onTabChanged($event)"></topo-tabs>
    </div>
  }

  @if (!!!dataset) {
    <div
    class="separator"></div>
  }

  <div class="content-body">
    @if (selectedTabIndex == 0 || !!!dataset) {
      <div>
        @for (response of recipientStats; track response.channelUId) {
          <div>
            <div
              class="recipient-card"
              fxLayout="column">
              <div class="body">
                <div
                  fxLayout="row"
                  fxLayoutAlign="space-between center">
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="8px"
                    class="channel-display"
                    [title]="response.address">
                    <i class="icon {{ response.icon }}"></i>
                    <div>{{ response.title }}</div>
                  </div>
                  <div>
                    <div
                      fxLayout="row"
                      fxLayoutAlign="start center">
                      <div
                        class="response-status"
                      [ngStyle]="{ 'background-color': getResponseStatusColor(response.status) }"></div>
                      <div class="response-status-text">{{ getResponseStatus(response.status) }}</div>
                    </div>
                  </div>
                </div>
                @if (response.address) {
                  <div
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                    class="address-display">
                    <div class="address">{{ response.address }}</div>
                    @if (response.responseTime) {
                      <div
                        class="time"
                        [title]="getDateDisplay(response.responseTime)">
                        {{ getDateDiff(response.responseTime) }}
                      </div>
                    }
                  </div>
                }
                @if (!!response.statusDetails) {
                  <div
                    class="status-detail-display"
                    >
                    {{ response.statusDetails }}
                  </div>
                }
              </div>
              @if (response.responseText) {
                <div
                  class="response-text-display">
                  {{ response.responseText }}
                </div>
              }
              @if (response.confirmationOptionsUId) {
                <div
                  class="confirmation-text-display"
                  [ngStyle]="{ 'background-color': getConfirmationColor(response) }">
                  {{ getConfirmationText(response) }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (selectedTabIndex == 1) {
      <div>
        @if (dataset) {
          <div>
            <div class="recipient-form">
              <div>
                <topo-form-group-select
                  (changed)="viewContainerChanged($event)"
                  [(ngModel)]="selectedViewControlContainerUId"
                  [selectedViewControlContainerUId]="selectedViewControlContainerUId"
                [viewControlContainers]="viewControlContainers"></topo-form-group-select>
              </div>
              <div
                class="mt-4"
                topoDynamicForm2
                [formView]="editView"
                [schema]="dataset?.schema"
                [layerUId]="guidEmpty"
                [document]="document"
                [controlCollection]="documentControls"
                [isEdit]="false"
                [dataset]="dataset"
              [viewContainer]="selectedViewContainer"></div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
